import React, { useEffect, useRef, useState } from 'react';

import { Box, Stack, TableCell, TableRow, TextField } from '@mui/material';

import { AdminAxios as Axios } from '../../Assets/Axios/Axios';

import { COLORS } from '../../Constant/COLORS';

import SearchField from './Components/SearchField';
import CustomTable from './Components/CustomTable';
import { TypoPoppins } from '../../Components/Typo';

import { PaymentsQuery } from '../../Server/Query';

const createTableRecord = ({
  no,
  profFirstName,
  profLastName,
  work,
  amount,
  transactionState,
  date,
}) => ({
  number: no.toString().padStart(2, '0'),
  profFullName: `${profFirstName ?? ''} ${profLastName ?? ''}`,
  work,
  amount,
  transactionState,
  date: new Date(date).toLocaleDateString(),
});

const Transaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [inputs, setInputs] = useState({ date: '', search: '' });

  const transactionsRef = useRef(null);

  useEffect(() => {
    Axios(PaymentsQuery).then(response => {
      if (!response || response.errors || !Array.isArray(response.data?.payments)) return;

      const { payments } = response.data;
      const allPayments = payments.map((payment, index) =>
        createTableRecord({
          no: index + 1,
          profFirstName: payment.paymentMethod ?? '',
          profLastName: '',
          work: payment.paymentId ?? '',
          amount: payment.amount,
          transactionState: payment.status,
          date: payment.createdAt,
        })
      );
      setTransactions(allPayments);
      transactionsRef.current = allPayments;
    });
  }, []);

  //to handle search and filter
  useEffect(() => {
    if (!Array.isArray(transactionsRef.current)) return;
    const filteredTransactions = transactionsRef.current.filter(transaction => {
      const shouldReturn = {
        date: true,
        search: true,
      };
      if (inputs.date)
        shouldReturn.date =
          new Date(transaction.date).setHours(0, 0, 0, 0).valueOf() ===
          new Date(inputs.date).setHours(0, 0, 0, 0).valueOf();

      if (inputs.search) shouldReturn.search = transaction.profFullName.startsWith(inputs.search);

      return shouldReturn.date && shouldReturn.search;
    });
    setTransactions(filteredTransactions);
  }, [inputs]);

  const handleChange = ({ target: { name, value } }) =>
    setInputs(prevState => ({ ...prevState, [name]: value }));

  return (
    <Box my={{ xs: 2.5, md: 5 }} px={{ xs: 2.5, md: 5 }}>
      <Stack gap={3} direction='row' alignItems='center' flexWrap='wrap'>
        <SearchField value={inputs.search} name='search' onChange={handleChange} />
        <Stack direction='row' alignItems='center' gap={{ xs: 1.5, md: 3 }} ml={{ md: 'auto' }}>
          <TypoPoppins color='rgba(0 0 0/.3)' fontWeight={500} ml='auto'>
            Event Date
          </TypoPoppins>
          <TextField
            value={inputs.date}
            type='date'
            sx={{ border: 'none' }}
            InputProps={{ sx: { bgcolor: COLORS.white3 } }}
            name='date'
            onChange={handleChange}
          />
        </Stack>

        {/* <IconButton>
          <MoreVertIcon htmlColor={COLORS.black} />
        </IconButton> */}
      </Stack>
      <TypoPoppins mt={3} mb={2} variant='body1'>
        Transaction Details
      </TypoPoppins>
      <CustomTable
        height='500px'
        tableHeadings={['No.', 'Prof. Full name', 'Work', 'Amount', 'Transaction State', 'Date']}>
        {transactions.map(row => (
          <TableRow key={row.number}>
            <TableCell>{row.number}</TableCell>
            <TableCell>{row.profFullName}</TableCell>
            <TableCell>{row.work}</TableCell>
            <TableCell>{row.amount}</TableCell>
            <TableCell>{row.transactionState}</TableCell>
            <TableCell>{row.date}</TableCell>
          </TableRow>
        ))}
      </CustomTable>
    </Box>
  );
};

export default Transaction;
